export const updateShipmentStatusEndpoint = (shipmentUid: string) =>
  `/shipments/${shipmentUid}/update-status`
